import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import { LogIn, Mail, Lock, ArrowRight, Loader, Eye, EyeOff } from "lucide-react";
import { useUserStore } from "../stores/useUserStore";
import toast from "react-hot-toast";

const LoginPage = () => {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [showPassword, setShowPassword] = useState(false);
	const navigate = useNavigate();

	const { login, loading, user } = useUserStore();

	// ניתוב לאחר התחברות מוצלחת
	useEffect(() => {
		if (user) {
			console.log('✅ משתמש מחובר, מנתב ל:', user.role === 'admin' ? '/admin' : '/');
			// אם המשתמש אדמין, נעביר אותו לדף הניהול
			if (user.role === 'admin') {
				navigate('/admin');
			} else {
				// אחרת נעביר לדף הבית
				navigate('/');
			}
		}
	}, [user, navigate]);

	const handleSubmit = async (e) => {
		e.preventDefault();
		
		if (!email || !password) {
			toast.error("אנא מלא את כל השדות");
			return;
		}

		console.log('🔐 מנסה להתחבר עם:', email);
		await login(email, password);
	};

	return (
		<div className='flex flex-col justify-center  bg-white py-14 sm:px-6 lg:px-8'>
			<motion.div
				className='sm:mx-auto sm:w-full sm:max-w-md'
				initial={{ opacity: 0, y: -20 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.8 }}
			>
				<h2 className='mt-10 text-center text-3xl font-extrabold text-brand-primary'>התחבר לחשבון שלך</h2>
			</motion.div>

			<motion.div
				className='mt-10 sm:mx-auto sm:w-full sm:max-w-md'
				initial={{ opacity: 0, y: 20 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.8, delay: 0.2 }}
			>
				<div className='bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10 border border-gray-200'>
					<form onSubmit={handleSubmit} className='space-y-6'>
						<div>
							<label htmlFor='email' className='block text-sm font-medium text-gray-700'>
								כתובת אימייל
							</label>
							<div className='mt-1 relative rounded-md shadow-sm'>
								<div className='absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none'>
									<Mail className='h-5 w-5 text-gray-600' aria-hidden='true' />
								</div>
								<input
									id='email'
									name='email'
									type='email'
									required
									value={email}
									onChange={(e) => setEmail(e.target.value)}
									className=' block w-full px-3 py-2 pl-10 bg-white border border-gray-300 
									rounded-md shadow-sm text-gray-900
									 placeholder-gray-500 focus:outline-none focus:ring-brand-primary 
									 focus:border-brand-primary sm:text-sm'
									placeholder='you@example.com'
									autoComplete='email'
								/>
							</div>
						</div>

						<div>
							<label htmlFor='password' className='block text-sm font-medium text-gray-700'>
								סיסמה
							</label>
							<div className='mt-1 relative rounded-md shadow-sm'>
								<div className='absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none'>
									<Lock className='h-5 w-5 text-gray-600' aria-hidden='true' />
								</div>
								<input
									id='password'
									name='password'
									type='password'
									required
									value={password}
									onChange={(e) => setPassword(e.target.value)}
									className=' block w-full px-3 py-2 pl-10 bg-white border border-gray-300 
									rounded-md shadow-sm text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-brand-primary focus:border-brand-primary sm:text-sm'
									placeholder='••••••••'
									autoComplete='current-password'
								/>
							</div>
						</div>

						<div className='flex items-center justify-between'>
							<div className='text-sm'>
								<Link
									to='/forgot-password'
									className='font-medium text-brand-primary text-brand-primary-hover transition-colors'
								>
									שכחת סיסמה? 🔐
								</Link>
							</div>
						</div>

						<button
							type='submit'
							className='w-full flex justify-center py-2 px-4 border border-transparent 
							rounded-md shadow-sm text-sm font-medium text-white bg-brand-primary
							 hover:bg-brand-primary-hover focus:outline-none focus:ring-2 focus:ring-offset-2
							  focus:ring-brand-primary transition duration-150 ease-in-out disabled:opacity-50'
							disabled={loading}
						>
							{loading ? (
								<>
									<Loader className='mr-2 h-5 w-5 animate-spin' aria-hidden='true' />
									Loading...
								</>
							) : (
								<>
									<LogIn className='mr-2 h-5 w-5' aria-hidden='true' />
									התחברות
								</>
							)}
						</button>
					</form>

					<p className='mt-8 text-center text-sm text-gray-600'>
						אין לך חשבון?{" "}
						<Link to='/signup' className='font-medium text-brand-primary text-brand-primary-hover'>
							הירשם עכשיו <ArrowRight className='inline h-4 w-4' />
						</Link>
					</p>
				</div>
			</motion.div>
		</div>
	);
};
export default LoginPage;
